/* eslint-disable react/no-unused-state */
import React from 'react';
import PropTypes from 'prop-types';
import { PersonalInfoProvider } from '../personalnfoContext';

export default class ContextWrapper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      enablePersonalInfoCTA: false,
      personalInfoSubmit: null,
      agreementStatus: false,
    };
  }

  updatePersonalInfoCTA = (status) => this.setState({ enablePersonalInfoCTA: status });

  getCTAStatus = () => this.state.enablePersonalInfoCTA;

  updatePersonalInfoListerner = (listener) => {
    this.setState({ personalInfoSubmit: listener });
  }

  setAgreementStatus = (value) => this.setState({agreementStatus : value});

  render() {
    const { children } = this.props
    const { state: { personalInfoSubmit, agreementStatus }, getCTAStatus, updatePersonalInfoCTA, updatePersonalInfoListerner, setAgreementStatus } = this;
    return (
      <PersonalInfoProvider value={{
        personalInfoSubmit,
        agreementStatus,
        getCTAStatus,
        updatePersonalInfoCTA,
        updatePersonalInfoListerner,
        setAgreementStatus,
      }}
      >
        {children}
      </PersonalInfoProvider>
    );
  }
}


ContextWrapper.propTypes = {
  children: PropTypes.any,
}
